import { localeNameSpaces, useIsolatedTranslation } from "@payping/utils/localeUtils";

export function useAppTranslation(): any {
  return useIsolatedTranslation(localeNameSpaces.Wrapper);
}
